"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignFormCms = void 0;
var AssignFormCms = /** @class */ (function () {
    function AssignFormCms() {
        this.areaCodeLabel = 'Area code';
        this.newNumberConsentLabel = "Select a preferred area code and location. We'll email\n     your new 10-digit mobile number. Keep in mind that your selections aren't guaranteed.";
        this.tradeInPromoNewNumberLabel = "<strong>Don't miss out!</strong></br>You'll need to\n     transfer your number to qualify for the port-in offer. Without the transfer, we'll\n      update your cart with only the trade-in offer.";
        this.prefferedAreaCodeLabel = 'Select a preferred area code';
        this.differentreaCodeLinkLabel = 'I want a different area code';
        this.locationLabel = 'Location';
        this.areaCodeInputBoxPlaceholder = 'XXXXXXX';
        this.locationInputBoxPlaceholder = 'XXX';
        this.retailerPortinAlert = "<strong> Don't miss out! </strong>Transfer your number to qualify for $[0] in bill credits.";
    }
    return AssignFormCms;
}());
exports.AssignFormCms = AssignFormCms;
//# sourceMappingURL=AssignForm.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/AssignForm/AssignForm.cms.js
// module id = 949
// module chunks = 8